import 'twin.macro'
import 'assets/styles/bvi.min.css'

import EyeIcon from 'assets/icons/eye.svg?component'
import Bvi from 'assets/js/bvi/bvi'
import { useEffect } from 'react'

const BVIButton = () => {
  useEffect(() => {
    const bvi = new Bvi({
      builtElements: true
    })

    return () => {
      bvi._remove()
    }
  }, [])

  return (
    <button className='bvi-open flex items-center justify-center w-8 h-8 rounded-full bg-[var(--bg-header-icon)]'>
      <EyeIcon />
    </button>
  )
}

export default BVIButton
